// eslint-disable-next-line no-promise-executor-return
export const delay = (ms: number): Promise<void> => new Promise((res) => setTimeout(res, ms));
